import { render } from "./BackToPharmacy.vue?vue&type=template&id=14811d0f"
import script from "./BackToPharmacy.vue?vue&type=script&lang=js"
export * from "./BackToPharmacy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__